"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleButtonGroup = exports.toggleButton = void 0;

var _size = _interopRequireDefault(require("../choices/size.const"));

var _color = _interopRequireDefault(require("../choices/color.const"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var toggleButton = {
  backgroundColor: _color["default"].cloudyBlue,
  backgroundColorSelected: _color["default"].dodgerBlue,
  knobColor: _color["default"].white,
  knobMargin: _size["default"].small,
  height: '20px',
  width: '32px',
  margin: _size["default"]["default"],
  knobSize: '14px'
};
exports.toggleButton = toggleButton;
var toggleButtonGroup = {
  verticalGroupMargin: _size["default"]["default"],
  horizontalGroupMargin: _size["default"].default2x
};
exports.toggleButtonGroup = toggleButtonGroup;